import { useQuery } from "@tanstack/react-query";
import { triggerPullGames } from "../api/triggerPullGames";

export const useTriggerPullGamesQuery = () => {
  return useQuery({
    queryKey: ["triggerPullGames"],
    queryFn: triggerPullGames,
    enabled: false,
  });
};
